import { useEffect, useState, ReactNode } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

import { Box } from '../../../../Box';
import { Typography } from '../../../../Typography';
import { getAllTextContent } from '../../utils';

interface CharacterLimitPluginProps {
  limit: number;
  descriptionComponent?: ReactNode;
}

export const CharacterLimitPlugin = ({
  limit,
  descriptionComponent,
}: CharacterLimitPluginProps) => {
  const [editor] = useLexicalComposerContext();
  const [charsLength, setCharsLength] = useState(0);
  const remainingChars = limit - charsLength;
  const charLimitAvailable = remainingChars >= 0;

  useEffect(() => {
    const removeUpdateListener = editor.registerUpdateListener(
      ({ editorState }) => {
        editorState.read(() => {
          const textContent = getAllTextContent(editorState);
          const currentLength = textContent.length;

          setCharsLength(currentLength);
        });
      },
    );

    return () => {
      removeUpdateListener();
    };
  }, [editor, limit]);

  if (!charLimitAvailable) {
    return (
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="caption" color="accent.text.error">
          {`Превышено допустимое количество символов: ${limit}. Сократите текст`}
        </Typography>
        <Typography variant="caption" color="accent.text.error">
          {remainingChars}
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      {descriptionComponent || (
        <Typography variant="caption" color="text.light.secondary">
          Количество символов ограничено
        </Typography>
      )}
      <Typography
        variant="caption"
        color={
          !!descriptionComponent ? 'accent.text.error' : 'text.light.secondary'
        }
      >
        {charsLength} / {limit}
      </Typography>
    </Box>
  );
};
